(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const init = (root = document) => {
    if ('IntersectionObserver' in window && !reduceMotion) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) { entry.target.classList.add('solve-in-view'); observer.unobserve(entry.target); }
        });
      }, { threshold: 0.08 });
      root.querySelectorAll('.solve-reveal').forEach(el => { el.classList.add('solve-can-reveal'); observer.observe(el); });
    }
    root.querySelectorAll('.solve-stories').forEach(section => {
      if (section.dataset.solveReady) return;
      section.dataset.solveReady = 'true';
      const rail = section.querySelector('.solve-stories-rail');
      if (!rail) return;
      const step = () => (rail.querySelector('article')?.getBoundingClientRect().width || 320) + 20;
      const direction = getComputedStyle(rail).direction === 'rtl' ? -1 : 1;
      section.querySelector('[data-solve-story-prev]')?.addEventListener('click', () => rail.scrollBy({left: -direction * step(), behavior: reduceMotion ? 'auto' : 'smooth'}));
      section.querySelector('[data-solve-story-next]')?.addEventListener('click', () => rail.scrollBy({left: direction * step(), behavior: reduceMotion ? 'auto' : 'smooth'}));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
